import { inject, Injectable } from '@angular/core';

import { translate } from '@jsverse/transloco';
import { ColDef } from 'ag-grid-enterprise';

import { Calculation } from '@cdba/shared/models';

import { ColumnUtilsService, valueGetterDate } from '../../table';

@Injectable()
export class ColumnDefinitionService {
  private readonly columnUtilsService = inject(ColumnUtilsService);

  COLUMN_DEFINITION: ColDef[] = [
    {
      field: 'calculationDate',
      headerName: translate('shared.calculations.table.calculationDate'),
      headerTooltip: translate('shared.calculations.table.calculationDate'),
      width: 170,
      valueGetter: (params) =>
        valueGetterDate<Calculation>(params, 'costingDate'),
      valueFormatter: this.columnUtilsService.formatDate,
      filter: 'agDateColumnFilter',
    },
    {
      field: 'costingVariant',
      headerName: translate('shared.calculations.table.costType'),
      headerTooltip: translate('shared.calculations.table.costType'),
      width: 120,
    },
    {
      field: 'price',
      headerName: translate('shared.calculations.table.price'),
      headerTooltip: translate('shared.calculations.table.price'),
      width: 110,
      filter: 'agNumberColumnFilter',
      type: 'numericColumn',
      valueFormatter: (params) =>
        this.columnUtilsService.formatNumber(params, {
          minimumFractionDigits: 3,
        }),
    },
    {
      field: 'currencyKey',
      headerName: translate('shared.calculations.table.currency'),
      headerTooltip: translate('shared.calculations.table.currency'),
      width: 130,
    },
    {
      field: 'priceUnit',
      headerName: translate('shared.calculations.table.priceUnit'),
      headerTooltip: translate('shared.calculations.table.priceUnit'),
      width: 120,
    },
    {
      field: 'plant',
      headerName: translate('shared.calculations.table.plant'),
      headerTooltip: translate('shared.calculations.table.plant'),
      width: 110,
    },
    {
      field: 'materialBudgetYearlyRequirement',
      headerName: translate('shared.calculations.table.quantity'),
      headerTooltip: translate('shared.calculations.table.quantity'),
      width: 120,
      filter: 'agNumberColumnFilter',
      type: 'numericColumn',
      valueFormatter: this.columnUtilsService.formatNumber,
    },
    {
      field: 'materialBudgetYearlyRequirementUnit',
      headerName: translate('shared.calculations.table.quantityUnit'),
      headerTooltip: translate('shared.calculations.table.quantityUnit'),
      width: 120,
    },
    {
      field: 'lotSize',
      headerName: translate('shared.calculations.table.lotSize'),
      headerTooltip: translate('shared.calculations.table.lotSize'),
      width: 120,
      filter: 'agNumberColumnFilter',
      type: 'numericColumn',
      valueFormatter: this.columnUtilsService.formatNumber,
    },
    {
      field: 'lotSizeUnit',
      headerName: translate('shared.calculations.table.lotSizeUnit'),
      headerTooltip: translate('shared.calculations.table.lotSizeUnit'),
      width: 120,
    },
    {
      field: 'version',
      headerName: translate('shared.calculations.table.costingVersion'),
      headerTooltip: translate('shared.calculations.table.costingVersion'),
      width: 160,
    },
  ];
}
